import { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Icon, ItemSelect } from '../filters/styles';
import { StyledClickOutside, OptionContainer, InputRadio } from './styles';

const Dropdown = ({
  label,
  onClose,
  onChange,
  value = null,
  options = [],
}) => {
  const [isOpened, setIsOpened] = useState(false);

  const handleClose = () => {
    setIsOpened(false);

    if (onClose) {
      onClose();
    }
  };

  const handleOpen = () => {
    setIsOpened(true);
  };

  const toggle = () => {
    if (isOpened) {
      return handleClose();
    }

    return handleOpen();
  };

  const handleChange = (event) => {
    onChange(event.target.value);

    handleClose();
  };

  const renderOption = (item) => {
    const { value: optionValue, text } = item;

    return (
      <span key={optionValue}>
        <InputRadio
          id={optionValue}
          type="radio"
          checked={value === item.value}
          value={item.value}
          onChange={handleChange}
        />
        <label htmlFor={optionValue}>{text}</label>
      </span>
    );
  };

  return (
    <StyledClickOutside onClickOutside={handleClose}>
      <ItemSelect>
        <em>
          {label}
        </em>
        <span onClick={toggle}>
          <span>
            {value.length !== 0 && <span>&nbsp;&nbsp;</span>}
            {options.find(({ value: selectedValue }) => value === selectedValue)?.text}
          </span>
          <Icon className="icon-arrow-down" />
        </span>
        <CSSTransition
          mountOnEnter
          unmountOnExit
          in={!!isOpened}
          appear={!!isOpened}
          timeout={300}
          classNames="fade"
        >
          <OptionContainer>
            {options.map(renderOption)}
          </OptionContainer>
        </CSSTransition>
      </ItemSelect>
    </StyledClickOutside>
  );
};

export default Dropdown;
